import { Component, Input } from '@angular/core';

import { MetricDataItem } from '../../../insight/performance-data/metric.pd.model';
import { TranslationKeyMap } from '../pillar-three.i18n';

@Component({
    selector: 'cmps-detail-grid',
    templateUrl: './detail-grid.component.html',
    host: {
        class: 'cmps-detail-grid',
    },
})
export class DetailGridComponent {
    /** @private */ _i18n = TranslationKeyMap;

    @Input() dates: Array<{ startDate: Date; endDate: Date }>;
    @Input() data: MetricDataItem[];
}
